export const FETCH_CONDITIONS_PAGE = "fetchConditionsPage";
